/**
 * Checks if the parameter is an array of numbers.
 */
export function isNumberArray(array: number[]): boolean {
  if (!(array instanceof Array)) return false;
  return array.every(element => typeof element === 'number');
}
